import type { ErrorEvent, EventHint } from "@sentry/react-router"
import { isAPIError } from "source/shared/utils/errorResponses"

export function sentryBeforeSend(
  event: ErrorEvent,
  { originalException }: EventHint,
): ErrorEvent {
  if (originalException instanceof Error || !isAPIError(originalException)) {
    return event
  }

  const { status, title, detail } = originalException.errors[0] ?? {}
  const exception = event.exception?.values?.[0]
  if (exception) {
    exception.type = "ApiError"
    exception.value = `${status} ${title}${detail ? `: ${detail}` : ""}`
  }

  event.contexts = { ...event.contexts, api_error: originalException }
  event.tags = { ...event.tags, "api_error.status": status }
  event.fingerprint = [
    "api-error",
    String(status),
    String(title),
    "{{ default }}",
  ]
  return event
}
